import { type MentionDescription, type MentionProvider } from '@atlaskit/mention';

export const getMentionProvider = (userId: string) => {
	return Promise.resolve({
		shouldHighlightMention(mention: MentionDescription) {
			return mention.id === userId;
		},
	} as MentionProvider);
};
